import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchProductsApi,
  fetchGroceryListsApi,
  saveGroceryListApi,
  fetchGroceryListItemsApi,
  updateGroceryListItemApi,
  deleteGroceryListItemApi,
  addGroceryListItemApi,
  updateGroceryListApi,
} from "./manavApi";

export const fetchProducts = createAsyncThunk(
  "manav/fetchProducts",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchProductsApi();
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.ExceptionMessage ||
            error.response.data.message ||
            "Ürün kataloğu alınamadı."
        );
      }
      return rejectWithValue("Ürün kataloğu alınırken bağlantı hatası oluştu.");
    }
  }
);

export const fetchGroceryLists = createAsyncThunk(
  "manav/fetchGroceryLists",
  async ({ page, size }, { rejectWithValue }) => {
    try {
      const data = await fetchGroceryListsApi(page, size);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.ExceptionMessage ||
            error.response.data.message ||
            "Manav listeleri alınamadı."
        );
      }
      return rejectWithValue("Manav listeleri alınırken bağlantı hatası oluştu.");
    }
  }
);

export const saveGroceryList = createAsyncThunk(
  "manav/saveGroceryList",
  async (payload, { rejectWithValue }) => {
    try {
      const data = await saveGroceryListApi(payload);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.ExceptionMessage ||
            error.response.data.message ||
            "Manav listesi kaydedilemedi."
        );
      }
      return rejectWithValue("Manav listesi kaydedilirken bağlantı hatası oluştu.");
    }
  }
);

export const fetchGroceryListItems = createAsyncThunk(
  "manav/fetchGroceryListItems",
  async (listId, { rejectWithValue }) => {
    try {
      const data = await fetchGroceryListItemsApi(listId);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.ExceptionMessage ||
            error.response.data.message ||
            "Liste detayları alınamadı."
        );
      }
      return rejectWithValue("Liste detayları alınırken bağlantı hatası oluştu.");
    }
  }
);

export const updateGroceryListItem = createAsyncThunk(
  "manav/updateGroceryListItem",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const data = await updateGroceryListItemApi(id, payload);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.ExceptionMessage ||
            error.response.data.message ||
            "Ürün güncellenemedi."
        );
      }
      return rejectWithValue("Ürün güncellenirken bağlantı hatası oluştu.");
    }
  }
);

export const deleteGroceryListItem = createAsyncThunk(
  "manav/deleteGroceryListItem",
  async (id, { rejectWithValue }) => {
    try {
      const data = await deleteGroceryListItemApi(id);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.ExceptionMessage ||
            error.response.data.message ||
            "Ürün silinemedi."
        );
      }
      return rejectWithValue("Ürün silinirken bağlantı hatası oluştu.");
    }
  }
);

export const addGroceryListItem = createAsyncThunk(
  "manav/addGroceryListItem",
  async (payload, { rejectWithValue }) => {
    try {
      const data = await addGroceryListItemApi(payload);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.ExceptionMessage ||
            error.response.data.message ||
            "Ürün eklenemedi."
        );
      }
      return rejectWithValue("Ürün eklenirken bağlantı hatası oluştu.");
    }
  }
);

export const updateGroceryList = createAsyncThunk(
  "manav/updateGroceryList",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const data = await updateGroceryListApi(id, payload);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.ExceptionMessage ||
            error.response.data.message ||
            "Liste güncellenemedi."
        );
      }
      return rejectWithValue("Liste güncellenirken bağlantı hatası oluştu.");
    }
  }
);
